import { IApiPaginate } from "core/networks/Interfaces";
import { Action } from "redux";
import { TypeSuggestion } from "../type";

export const FETCH_MY_INGREDIENTS_REQUEST = "FETCH_MY_INGREDIENTS_REQUEST";
export const FETCH_MY_INGREDIENTS_SUCCESS = "FETCH_MY_INGREDIENTS_SUCCESS";
export const FETCH_MY_INGREDIENTS_ERROR = "FETCH_MY_INGREDIENTS_ERROR";

export const FETCH_RANDOM_RECIPE_REQUEST = "FETCH_RANDOM_RECIPE_REQUEST";
export const FETCH_RANDOM_RECIPE_SUCCESS = "FETCH_RANDOM_RECIPE_SUCCESS";
export const FETCH_RANDOM_RECIPE_ERROR = "FETCH_RANDOM_RECIPE_ERROR";

export const FETCH_SUGGESTION_BY_TYPE_REQUEST = "FETCH_SUGGESTION_BY_TYPE_REQUEST";
export const FETCH_SUGGESTION_BY_TYPE_SUCCESS = "FETCH_SUGGESTION_BY_TYPE_SUCCESS";
export const FETCH_SUGGESTION_BY_TYPE_ERROR = "FETCH_SUGGESTION_BY_TYPE_ERROR";

export const FETCH_FAVORITES_MAIN_REQUEST = "FETCH_FAVORITES_MAIN_REQUEST";
export const FETCH_FAVORITES_MAIN_SUCCESS = "FETCH_FAVORITES_MAIN_SUCCESS";
export const FETCH_FAVORITES_MAIN_ERROR = "FETCH_FAVORITES_MAIN_ERROR";

export const FETCH_COUPANG_RECO_REQUEST = "FETCH_COUPANG_RECO_REQUEST";
export const FETCH_COUPANG_RECO_SUCCESS = "FETCH_COUPANG_RECO_SUCCESS";
export const FETCH_COUPANG_RECO_ERROR = "FETCH_COUPANG_RECO_ERROR";

export const FETCH_WEATHER_MAIN_REQUEST = "FETCH_WEATHER_MAIN_REQUEST";
export const FETCH_WEATHER_MAIN_SUCCESS = "FETCH_WEATHER_MAIN_SUCCESS";
export const FETCH_WEATHER_MAIN_ERROR = "FETCH_WEATHER_MAIN_ERROR";

export const FETCH_HISTORY_MAIN_REQUEST = "FETCH_HISTORY_MAIN_REQUEST";
export const FETCH_HISTORY_MAIN_SUCCESS = "FETCH_HISTORY_MAIN_SUCCESS";
export const FETCH_HISTORY_MAIN_ERROR = "FETCH_HISTORY_MAIN_ERROR";

export const FETCH_COMMUNITY_TREND_MAIN_REQUEST = "FETCH_COMMUNITY_TREND_MAIN_REQUEST";
export const FETCH_COMMUNITY_TREND_MAIN_SUCCESS = "FETCH_COMMUNITY_TREND_MAIN_SUCCESS";
export const FETCH_COMMUNITY_TREND_MAIN_ERROR = "FETCH_COMMUNITY_TREND_MAIN_ERROR";

export const FETCH_COMMUNITY_FOLLOW_MAIN_REQUEST = "FETCH_COMMUNITY_FOLLOW_MAIN_REQUEST";
export const FETCH_COMMUNITY_FOLLOW_MAIN_SUCCESS = "FETCH_COMMUNITY_FOLLOW_MAIN_SUCCESS";
export const FETCH_COMMUNITY_FOLLOW_MAIN_ERROR = "FETCH_COMMUNITY_FOLLOW_MAIN_ERROR";

export const FETCH_COMMUNITY_VIDEO_MAIN_REQUEST = "FETCH_COMMUNITY_VIDEO_MAIN_REQUEST";
export const FETCH_COMMUNITY_VIDEO_MAIN_SUCCESS = "FETCH_COMMUNITY_VIDEO_MAIN_SUCCESS";
export const FETCH_COMMUNITY_VIDEO_MAIN_ERROR = "FETCH_COMMUNITY_VIDEO_MAIN_ERROR";

export const REMOVE_FAVORITES_MAIN = "REMOVE_FAVORITES_MAIN";

export const FETCH_USER_SUGGESTION_MAIN_REQUEST = "FETCH_USER_SUGGESTION_MAIN_REQUEST";
export const FETCH_USER_SUGGESTION_MAIN_SUCCESS = "FETCH_USER_SUGGESTION_MAIN_SUCCESS";
export const FETCH_USER_SUGGESTION_MAIN_ERROR = "FETCH_USER_SUGGESTION_MAIN_ERROR";
export const RELOAD_USER_SUGGESTION_MAIN_REQUEST = "RELOAD_USER_SUGGESTION_MAIN_REQUEST";

export interface IFetchMyIngredientsRequest {
  page: number;
  page_size: number;
  refresh: number;
}
interface IFetchMyIngredients {
  id: number;
  icon: string;
  name: string;
  state: string | null;
  translate: any;
  created_at: string;
  updated_at: string;
}
export type IFetchMyIngredientsResponse =
  | IFetchMyIngredients
  | IApiPaginate<IFetchMyIngredients>;

export interface IFetchMyIngredientsRequestAction
  extends Action<typeof FETCH_MY_INGREDIENTS_REQUEST> {
  payload: IFetchMyIngredientsRequest;
}

export interface IFetchMyIngredientsSuccessAction
  extends Action<typeof FETCH_MY_INGREDIENTS_SUCCESS> {
  payload: IFetchMyIngredientsResponse;
}

export interface IFetchMyIngredientsErrorAction
  extends Action<typeof FETCH_MY_INGREDIENTS_ERROR> {
  payload: Error;
}


// Random Recipe

export interface IFetchRandomRecipeRequest {
  page: number;
  page_size: number;
}
interface IFetchRandomRecipe {
  id: number;
  icon: string;
  name: string;
  state: string | null;
  translate: any;
  created_at: string;
  updated_at: string;
}
export type IFetchRandomRecipeResponse =
  | IFetchRandomRecipe
  | IApiPaginate<IFetchRandomRecipe>;

export interface IFetchRandomRecipeRequestAction
  extends Action<typeof FETCH_RANDOM_RECIPE_REQUEST> {
  payload: IFetchRandomRecipeRequest;
}

export interface IFetchRandomRecipeSuccessAction
  extends Action<typeof FETCH_RANDOM_RECIPE_SUCCESS> {
  payload: IFetchRandomRecipeResponse;
}

export interface IFetchRandomRecipeErrorAction
  extends Action<typeof FETCH_RANDOM_RECIPE_ERROR> {
  payload: Error;
}


// suggest by type
export interface IFetchSuggestionByTypeRequest {
  page: number;
  page_size: number;
  type: TypeSuggestion;
}
export interface IFetchSuggestionByType {
  id: number;
  sort: string;
  title: string;
  description: string | null;
  thumbnail: string | undefined;
  flavor_items: any;
  created_at?: string;
  updated_at?: string;
  type?: TypeSuggestion;
}
export type IFetchSuggestionByTypeResponse =
  | IFetchSuggestionByType
  | IApiPaginate<IFetchSuggestionByType>;

export interface IFetchSuggestionByTypeRequestAction
  extends Action<typeof FETCH_SUGGESTION_BY_TYPE_REQUEST> {
  payload: IFetchSuggestionByTypeRequest;
}

export interface IFetchSuggestionByTypeSuccessAction
  extends Action<typeof FETCH_SUGGESTION_BY_TYPE_SUCCESS> {
  payload: IFetchSuggestionByTypeResponse;
  params: TypeSuggestion;
}

export interface IFetchSuggestionByTypeErrorAction
  extends Action<typeof FETCH_SUGGESTION_BY_TYPE_ERROR> {
  payload: Error;
}

//FAVORITE MAIN
export interface IFetchFavoritesMainRequest {
  page: number;
  page_size: number;
  refresh: number;
}

export interface IFetchWeatherMainRequest {
  page?: number;
  page_size?: number;
  refresh?: number;
}

export interface IFetchHistoryMainRequest {
  page?: number;
  page_size?: number;
  refresh?: number;
}

export interface IFetchCommunityTrendMainRequest {
  page?: number;
  page_size?: number;
  refresh?: number;
}

export interface IFetchCommunityFollowMainRequest {
  page?: number;
  page_size?: number;
  refresh?: number;
}

export interface IFetchCommunityVideoMainRequest {
  page?: number;
  page_size?: number;
  refresh?: number;
}

export interface IRemoveFavoritesMain {
  id: number;
}


interface IFetchFavoritesMain {
  id: number;
  icon: string;
  name: string;
  state: string | null;
  translate: any;
  created_at: string;
  updated_at: string;
}

interface IFetchWeatherMain {
  id: number;
  icon: string;
  name: string;
  state: string | null;
  translate: any;
  created_at: string;
  updated_at: string;
}

interface IFetchCommunityMain {
  id: number;
  icon: string;
  name: string;
  state: string | null;
  translate: any;
  created_at: string;
  updated_at: string;
}

export type IFetchFavoritesMainResponse =
  | IFetchFavoritesMain
  | IApiPaginate<IFetchFavoritesMain>;

export interface IFetchFavoritesMainRequestAction
  extends Action<typeof FETCH_FAVORITES_MAIN_REQUEST> {
  payload: IFetchFavoritesMainRequest;
}

export interface IRemoveFavoritesMainAction
  extends Action<typeof REMOVE_FAVORITES_MAIN> {
  payload: IRemoveFavoritesMain;
}

export interface IFetchFavoritesMainSuccessAction
  extends Action<typeof FETCH_FAVORITES_MAIN_SUCCESS> {
  payload: IFetchFavoritesMainResponse;
}

export interface IFetchFavoritesMainErrorAction
  extends Action<typeof FETCH_FAVORITES_MAIN_ERROR> {
  payload: Error;
}

export type IFetchWeatherMainResponse =
  | IFetchWeatherMain
  | IApiPaginate<IFetchWeatherMain>;

export type IFetchHistoryMainResponse =
  | IFetchWeatherMain
  | IApiPaginate<IFetchWeatherMain>;

export type IFetchCommunityMainResponse =
| IFetchCommunityMain
| IApiPaginate<IFetchCommunityMain>;

export interface IFetchWeatherMainRequestAction
  extends Action<typeof FETCH_WEATHER_MAIN_REQUEST> {
  payload: IFetchWeatherMainRequest;
}


export interface IFetchWeatherMainSuccessAction
  extends Action<typeof FETCH_WEATHER_MAIN_SUCCESS> {
  payload: IFetchWeatherMainResponse;
}

export interface IFetchWeatherMainErrorAction
  extends Action<typeof FETCH_WEATHER_MAIN_ERROR> {
  payload: Error;
}

export interface IFetchHistoryMainRequestAction
  extends Action<typeof FETCH_HISTORY_MAIN_REQUEST> {
  payload: IFetchHistoryMainRequest;
}


export interface IFetchHistoryMainSuccessAction
  extends Action<typeof FETCH_HISTORY_MAIN_SUCCESS> {
  payload: IFetchHistoryMainResponse;
}

export interface IFetchHistoryMainErrorAction
  extends Action<typeof FETCH_HISTORY_MAIN_ERROR> {
  payload: Error;
}

export interface IFetchCommunityTrendMainRequestAction
  extends Action<typeof FETCH_COMMUNITY_TREND_MAIN_REQUEST> {
  payload: IFetchCommunityTrendMainRequest;
}


export interface IFetchCommunityTrendMainSuccessAction
  extends Action<typeof FETCH_COMMUNITY_TREND_MAIN_SUCCESS> {
  payload: IFetchCommunityMainResponse;
}

export interface IFetchCommunityTrendMainErrorAction
  extends Action<typeof FETCH_COMMUNITY_TREND_MAIN_ERROR> {
  payload: Error;
}

export interface IFetchCommunityFollowMainRequestAction
  extends Action<typeof FETCH_COMMUNITY_FOLLOW_MAIN_REQUEST> {
  payload: IFetchCommunityFollowMainRequest;
}


export interface IFetchCommunityFollowMainSuccessAction
  extends Action<typeof FETCH_COMMUNITY_FOLLOW_MAIN_SUCCESS> {
  payload: IFetchCommunityMainResponse;
}

export interface IFetchCommunityFollowMainErrorAction
  extends Action<typeof FETCH_COMMUNITY_FOLLOW_MAIN_ERROR> {
  payload: Error;
}


export interface IFetchCommunityVideoMainRequestAction
  extends Action<typeof FETCH_COMMUNITY_VIDEO_MAIN_REQUEST> {
  payload: IFetchCommunityVideoMainRequest;
}


export interface IFetchCommunityVideoMainSuccessAction
  extends Action<typeof FETCH_COMMUNITY_VIDEO_MAIN_SUCCESS> {
  payload: IFetchCommunityMainResponse;
}

export interface IFetchCommunityVideoMainErrorAction
  extends Action<typeof FETCH_COMMUNITY_VIDEO_MAIN_ERROR> {
  payload: Error;
}
export interface IFetchUserSuggestionMainRequestAction
  extends Action<typeof FETCH_USER_SUGGESTION_MAIN_REQUEST> {
  payload: IFetchWeatherMainRequest;
}


export interface IFetchUserSuggestionMainSuccessAction
  extends Action<typeof FETCH_USER_SUGGESTION_MAIN_SUCCESS> {
  payload: IFetchWeatherMainResponse;
}

export interface IFetchUserSuggestionMainErrorAction
  extends Action<typeof FETCH_USER_SUGGESTION_MAIN_ERROR> {
  payload: Error;
}

export interface IReloadUserSuggestionMainRequestAction
  extends Action<typeof RELOAD_USER_SUGGESTION_MAIN_REQUEST> {
  payload: IFetchWeatherMainRequest;
}

